module.exports = __webpack_public_path__ + "img/type_box_link.6a76a0d7.jpg";